export const ADD_TODO = "ADD_TODO";
export const TOGGLE_TODO = "TOGGLE_TODO";
export const SET_FILTER = "SET_FILTER";
export const  DELETE_TODO= "DELETE_TODO";
export const  SET_SORT= "SET_SORT";
